export const HISTORY_FAULT_GRID_DEFAULT_TEMPLATE = {
  op: 'if',
  condition: true,
  then: [
    {
      op: 'ui',
      name: 'DialogTitle',
      component: 'div',
      sx: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 2,
      },
      children: [
        {
          op: 'ui',
          name: 'Stack',
          spacing: 1,
          children: [
            {
              op: 'if',
              condition: {
                op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
              },
              then: {
                op: 'ui',
                name: 'Stack',
                gap: 1,
                'data-testid': 'fault-source-description',
                children: [
                  {
                    op: 'ui',
                    name: 'Stack',
                    direction: 'row',
                    width: '100%',
                    gap: 1,
                    alignItems: 'center',
                    'data-testid': 'fault-code',
                    children: [
                      {
                        op: 'ui',
                        name: 'Icon',
                        fontSize: '1.25rem',
                        icon: 'Warning',
                        color: 'warning',
                      },
                      {
                        op: 'ui',
                        name: 'FaultSourceDescription',
                        eventData: { op: 'context', path: 'item.event.data' },
                        thingId: { op: 'context', path: 'item.event.thingId' },
                        eventId: { op: 'context', path: 'item.event.eventId' },
                      },
                    ],
                  },

                  {
                    op: 'context',
                    path: 'faultDescription',
                  },

                ],
              },
              else: [
                {
                  op: 'ui',
                  name: 'Typography',
                  children: {
                    op: 'ui',
                    name: 'Stack',
                    direction: 'row',
                    gap: 1,
                    alignItems: 'center',
                    'data-testid': 'fault-code',
                    children: [
                      {
                        op: 'ui',
                        name: 'Icon',
                        fontSize: '1.25rem',
                        icon: 'Warning',
                        color: 'warning',
                      },
                      {
                        op: 'context',
                        path: 'item.event.data.code',
                      },
                    ],
                  },
                },
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'caption',
                  color: 'textSecondary',
                  'data-testid': 'failure-mode-identifier',
                  children: {
                    op: 'if',
                    condition: {
                      op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
                    },
                    then: [
                      'FMI - ',
                      {
                        op: 'context',
                        path: 'item.event.data.failureModeIdentifier',
                      },
                    ],
                    else: {
                      op: 'context',
                      path: 'item.event.data.faultItem',
                    },
                  },
                },
              ],
            },
          ],
        },
        {
          op: 'ui',
          name: 'Stack',
          alignItems: 'flex-end',
          textAlign: 'right',
          spacing: 1,
          children: [
            {
              op: 'if',
              condition: {
                op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
              },
              then: {
                op: 'ui',
                name: 'RecommendationLabel',
                eventData: {
                  op: 'context',
                  path: 'item.event.data',
                },
                thingId: {
                  op: 'context',
                  path: 'item.event.thingId',
                },
              },
              else: null,
            },
            {
              op: 'ui',
              name: 'Box',
              children: [
                {
                  op: 'ui',
                  name: 'Typography',
                  'data-testid': 'occurrence-count',
                  children: {
                    op: 'translate',
                    translation: 'track:page.history.occurred-times.labels',
                    count: {
                      op: 'array-length',
                      value: {
                        op: 'context',
                        path: 'item.originalEvents',
                      },
                    },
                  },
                },
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'body2',
                  color: 'textSecondary',
                  'data-testid': 'first-event-occurred',
                  children: {
                    op: 'translate',
                    translation: 'track:page.history.since.labels',
                    date: {
                      op: 'format-timestamp',
                      value: {
                        op: 'context',
                        path: 'item.firstEventOccurred',
                      },
                    },
                  },
                },
              ],
            },
            {
              op: 'ui',
              name: 'Stack',
              direction: 'row',
              spacing: 1,
              alignItems: 'center',
              children: [
                {
                  op: 'ui',
                  name: 'Typography',
                  'data-testid': 'fault-status',
                  children: {
                    op: 'translate',
                    translation: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'item.isOngoing',
                      },
                      then: 'track:page.history.fault-active-long.labels',
                      else: 'track:page.history.fault-cleared-long.labels',
                    },
                  },
                },
                {
                  op: 'ui',
                  name: 'Box',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  flexShrink: 0,
                  backgroundColor: {
                    op: 'theme-property',
                    path: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'item.isOngoing',
                      },
                      then: 'palette.error.light',
                      else: 'palette.success.light',
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      op: 'ui',
      name: 'DialogContent',
      children: {
        op: 'ui',
        name: 'DataGrid',
        className: 'grid-pointer-rows',
        disableSelectionOnClick: true,
        pageSize: 10,
        paginationMode: 'client',
        disableColumnMenu: true,
        autoHeight: true,
        onRowClick: {
          op: 'context',
          path: 'onRowClick',
        },
        rows: {
          op: 'map',
          array: {
            op: 'context',
            path: 'item.originalEvents',
          },
          as: 'event',
          body: {
            id: {
              op: 'context',
              path: 'event.eventId',
            },
            occurred: {
              op: 'context',
              path: 'event.occurred',
            },
            address: {
              op: 'context',
              path: 'event.data.location.address',
            },
            location: {
              op: 'context',
              path: 'event.data.location',
            },
            active: {
              op: 'context',
              path: 'event.data.active',
            },
          },
        },
        columns: {
          op: 'map',
          array: [
            {
              field: 'occurred',
              translation: 'common:Occurred',
              template: {
                op: 'format-timestamp',
                value: {
                  op: 'context',
                  path: 'occurred',
                },
              },
              flex: 1,
            },
            {
              field: 'address',
              translation: 'common:Address',
              template: {
                op: 'if',
                condition: {
                  op: 'context',
                  path: 'address',
                },
                then: {
                  op: 'ui',
                  name: 'FormatAddress',
                  value: {
                    op: 'context',
                    path: 'address',
                  },
                  addressUnavailableText: {
                    op: 'translate',
                    translation: 'common:page.thing-map.address-unavailable.hint',
                  },
                  typographyProps: {
                    lineHeight: '24px',
                  },
                },
                else: {
                  op: 'ui',
                  name: 'EventAddress',
                  location: {
                    op: 'context',
                    path: 'location',
                  },
                  addressUnavailableText: {
                    op: 'translate',
                    translation: 'common:page.thing-map.address-unavailable.hint',
                  },
                },
              },
              flex: 1,
            },
            {
              field: 'active',
              translation: 'track:page.history.fault-status.labels',
              align: 'right',
              template: {
                op: 'ui',
                name: 'Stack',
                spacing: 1,
                direction: 'row',
                alignItems: 'center',
                children: [
                  {
                    op: 'ui',
                    name: 'Box',
                    component: 'span',
                    children: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'active',
                      },
                      then: {
                        op: 'translate',
                        translation: 'track:page.history.fault-active.labels',
                      },
                      else: {
                        op: 'translate',
                        translation: 'track:page.history.fault-cleared.labels',
                      },
                    },
                  },
                  {
                    op: 'ui',
                    name: 'Box',
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flexShrink: 0,
                    backgroundColor: {
                      op: 'theme-property',
                      path: {
                        op: 'if',
                        condition: {
                          op: 'context',
                          path: 'active',
                        },
                        then: 'palette.error.light',
                        else: 'palette.success.light',
                      },
                    },
                  },
                ],
              },
              flex: 1,
            },
          ],
          as: 'headers',
          body: {
            field: {
              op: 'context',
              path: 'headers.field',
            },
            flex: {
              op: 'context',
              path: 'headers.flex',
            },
            headerName: {
              op: 'translate',
              translation: {
                op: 'context',
                path: 'headers.translation',
              },
            },
            template: {
              op: 'context',
              path: 'headers.template',
            },
            align: {
              op: 'context',
              path: 'headers.align',
            },
            headerAlign: {
              op: 'context',
              path: 'headers.align',
            },
            sortable: false,
          },
        },
      },
    },
  ],
};
